/* @flow */
import React from 'react';
import { graphql, createFragmentContainer } from 'react-relay';
import { List } from 'material-ui/List';

import StudentJobRequest from './StudentJobRequest';

const StudentPending = ({ student: { jobRequests: { edges } } }) => (
  <div>
    {edges.length > 0 ? (
      <List>
        {edges.map(({ node }) => (
          <StudentJobRequest key={node.id} node={node} />
        ))}
      </List>
    ) : (
      <div style={{ padding: 10 }}>No Job Requests Found</div>
    )}
  </div>
);

export default createFragmentContainer(StudentPending, {
  student: graphql`
    fragment StudentPending_student on Student {
      jobRequests(first: 10, status: [Open]) {
        edges {
          node {
            id
            status
            createdAt
            subject {
              name
            }
            grade {
              name
            }
            offers {
              status
              createdAt
              tutor {
                firstname
                lastname
                profilePictureUri
              }
            }
            sessions {
              timeSlots {
                id
                startDate
                duration {
                  hours
                  minutes
                }
              }
            }
          }
        }
        pageInfo {
          hasNextPage
        }
      }
    }
  `,
});



// WEBPACK FOOTER //
// ./src/modules/admin/student/components/StudentPending.js